export const shopeeImgLink =
  "https://cdngarenanow-a.akamaihd.net/shopee/shopee-pcmall-live-sg/assets/ca5d12864c12916c05640b36e47ac5c9.png";

export const shopeePayVnHomePageURL = "https://shopeepay.vn";
export const shopeePayVnFeaturePageURL = "https://shopeepay.vn/tinh-nang";
export const shopeePayVnMerchantPageURL = "https://shopeepay.vn/doi-tac";
export const shopeePayVnMerchantRegistrationPageURL = "https://shopeepay.vn/hop-tac-doanh-nghiep";
export const shopeePayVnPromoPageURL = "https://shopeepay.vn/khuyen-mai";
export const shopeePayVnDownloadPageURL = "https://shopeepay.vn/tai-ung-dung";
export const shopeePayVnTermsPageURL = "https://shopeepay.vn/dieu-khoan-su-dung";
export const shopeePayVnPrivacyPageURL = "https://shopeepay.vn/chinh-sach-bao-mat";
export const shopeePayVnPrivacyOldVersionPageURL = "https://shopeepay.vn/chinh-sach-bao-mat/12-2022";
export const shopeePayVnContactUsPageURL = "https://shopeepay.vn/lien-he-chung-toi";
export const shopeePayVnBankPageURL = "https://shopeepay.vn/lien-ket-ngan-hang";

export const shopeePayMyHomePageURL = "https://shopeepay.com.my";
export const shopeePayMyFeaturePageURL = "https://shopeepay.com.my/feature";
export const shopeePayMyMerchantPageURL = "https://shopeepay.com.my/merchant";
export const shopeePayMyDownloadPageURL = "https://shopeepay.com.my/download";
export const shopeePayMyTermsPageURL = "https://shopeepay.com.my/terms";
export const shopeePayMyPrivacyPageURL = "https://shopeepay.com.my/privacy";
export const shopeePayMyContactUsPageURL =
  "https://shopeepay.com.my/contact-us";

export const shopeePayThHomepageURL = "https://shopeepay.co.th";
export const shopeePayIdHomepageURL = "https://shopeepay.co.id";
export const shoeePayIdFeaturePageURL = "https://shopeepay.co.id/fitur";
export const shopeePayIdMerchantPageURL = "https://shopeepay.co.id/merchant";
export const shopeePayIdDownloadPageURL = "https://shopeepay.co.id/download";
export const shopeePayIdTermsPageURL = "https://shopeepay.co.id/terms";
export const shopeePayIdPrivacyPageURL = "https://shopeepay.co.id/privacy";
export const shopeePayIdPromoPageURL = "https://shopeepay.co.id/promo";

export const shopeePayThServicePageURL = "https://shopeepay.co.th/service";
export const shopeePayThMerchantPageURL = "https://shopeepay.co.th/merchant";
export const shopeePayThContactPageURL = "https://shopeepay.co.th/contact-us";
export const shopeePayThDownloadPageURL = "https://shopeepay.co.th/download";
export const shopeePayThTermsPageURL = "https://shopeepay.co.th/terms";
export const shopeePayThPrivacyPageURL = "https://shopeepay.co.th/privacy";
export const shopeePayThFaqPageURL = "https://shopeepay.co.th/faq";

export const shopeePaySgHomePageURL= "https://shopeepay.sg";
export const shopeePaySgFeaturePageURL = "https://shopeepay.sg/consumer";
export const shopeePaySgMerchantPageURL = "https://shopeepay.sg/merchant";
export const shopeePaySgFaqPageURL = "https://shopeepay.sg/faq";
export const shopeePaySgContactPageURL = "https://shopeepay.sg/contact-us";
export const shopeePaySgDownloadPageURL = "https://shopeepay.sg/download";
export const shopeePaySgTermsPageURL = "https://shopeepay.sg/terms";
export const shopeePaySgPrivacyPageURL = "https://shopeepay.sg/privacy";

export const shopeePayPhHomePageURL= "https://shopeepay.ph";
export const shopeePayPhFeaturePageURL = "https://shopeepay.ph/feature";
export const shopeePayPhMerchantPageURL = "https://shopeepay.ph/merchant";
export const shopeePayPhPromoPageURL = "https://shopeepay.ph/promo";
export const shopeePayPhContactPageURL = "https://shopeepay.ph/contact-us";
export const shopeePayPhDownloadPageURL = "https://shopeepay.ph/download";

export const vnHrefLang = "vi-VN";
export const thHrefLang = "th-TH";
export const idHrefLang = "id-ID";
export const myHrefLang = "en-MY";
export const sgHrefLang = "en-SG";
export const phHrefLang = "en-PH";

export const shopeepayVnName = "ShopeePay Việt Nam";
export const shopeePayVnHomePageTitle =
  "ShopeePay | Ví Điện Tử Thanh Toán Mọi Lúc Mọi Nơi";
export const shopeePayVnHomePageContent =
  "Ứng dụng Ví tiền điện tử đáp ứng mọi nhu cầu thanh toán của bạn một cách nhanh chóng, mọi lúc mọi nơi với độ an toàn bảo mật thông tin cao. Thanh toán mua sắm online trên Shopee, quét mã QR thanh toán, nạp thẻ điện thoại, thanh toán hóa đơn với ưu đãi hoàn tiền, voucher hấp dẫn. Liên kết ShopeePay ngay!";

export const shoopeePayVnFeaturePageTitle = "Tính năng | ShopeePay Việt Nam";
export const shoopeePayVnFeaturePageContent =
  "An tâm khi thanh toán qua ShopeePay với các tính năng an toàn như xác nhận danh tính và chế độ bảo mật cao. Với ShopeePay, bạn có thể chuyển tiền cho người dùng khác hoặc đến tài khoản ngân hàng của họ dễ dàng và nhanh chóng.";

export const shopeePayVnMerchantPageTitle = "Đối Tác | ShopeePay Việt Nam";
export const shopeePayVnMerchantPageContent =
  "Đăng ký hợp tác với ShopeePay ngay hôm nay nếu bạn đang kinh doanh offline hay online để tận hưởng nhiều ưu đãi như thanh toán tích hợp và đa dạng các khuyến mãi hấp dẫn khác.";

export const shopeePayVnMerchantRegistrationPageTitle = "Trở thành đối tác của ShopeePay | ShopeePay Việt Nam";
export const shopeePayVnMerchantRegistrationPageContent = "Điền vào đơn đăng ký dưới đây để có cơ hội hợp tác cùng ShopeePay ngay hôm nay!";

export const shopeePayVnPromoPageTitle = "Khuyến mãi | ShopeePay Việt Nam";
export const shopeePayVnPromoPageContent = "Nhận ngay các ưu đãi và khuyến mãi hấp dẫn từ ShopeePay để thỏa thích mua sắm.";

export const shopeePayVnBankPageTitle = "Liên kết ngân hàng | ShopeePay Việt Nam";
export const shopeePayVnBankPageContent = "Kiểm tra danh sách các đối tác ngân hàng của ShopeePay tại đây và liên kết tài khoản của bạn ngay hôm nay để có thể thanh toán mọi lúc mọi nơi.";

export const shopeePayVnFaqPageTitle = "Trung Tâm Trợ Giúp | ShopeePay Việt Nam";
export const shopeePayVnFaqPageContent = "Bạn có thể tìm thấy câu trả lời cho những thắc mắc thường gặp tại đây.";

export const shopeePayVnContactUsPageTitle = "Liên hệ | ShopeePay Việt Nam";
export const shopeePayVnContactUsPageContent = "Nếu bạn có bất kỳ câu hỏi hay vấn đề, hãy liên hệ với chúng tôi tại đây.";

export const shopeePayVnDownloadPageTitle = "Tải ứng dụng | ShopeePay Việt Nam";
export const shopeePayVnDownloadPageContent =
  "ShopeePay đã có mặt trên Google Play và App Store, tải ứng dụng ngay hôm nay!";

export const shopeePayVnTermsPageTitle =
  "Điều khoản sử dụng | ShopeePay Việt Nam";
export const shopeePayVnTermsPageContent =
  "Đọc các điều khoản sử dụng tại đây.";

export const shopeePayVnPrivacyPageTitle =
  "Chính sách bảo mật | ShopeePay Việt Nam";
export const shopeePayVnPrivacyPageContent = "Đọc chính sách bảo mật tại đây.";
